$(() => {
    initializeHyperlinksClass();
});

function initializeHyperlinksClass() {
    $(".layout-column-middle").each(function () {
        new HyperlinksStyle(this);
    });
    $(".gdpr-banner").each(function() {
        new HyperlinksStyle(this);
    });
    $(".related-links-wrapper").each(function() {
        new HyperlinksStyle(this);
    });
}

class HyperlinksStyle {

    el: JQuery<HTMLElement>;

    constructor(hyperlinkContainerElement: HTMLElement) {
        this.el = $(hyperlinkContainerElement);
        const richText = this.el.find('.rich-text');
        const noClassHyperlink = richText.find($('a:not([class])'));
        const linksWithoutImg = noClassHyperlink.not(":has(img)");

        linksWithoutImg.css("transition", ".15s ease-in");
        linksWithoutImg.css('border-bottom', 'solid 1px transparent');
        linksWithoutImg.on({
            mouseenter: function () {
                $(this).css("border-bottom", "1px solid #3333ff");
            },
            mouseleave: function () {
                $(this).css("border-bottom", "solid 1px transparent");
            }
        });
        linksWithoutImg.focus(function() {
            $(this).css("border-bottom", "1px solid #3333ff");
        });
    }
}
